import axios from 'axios';
import React, { useEffect, useState } from 'react';

const ThankYouPage = ({ value,companyId, baseURL }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    getThankYouData();
  },[]);
  const getThankYouData = async () => {
    try {
      const res = await axios.get(`${baseURL}/dashboard-review/thank/${companyId}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      console.log('getThankYouData res', res);
      setData(res?.data?.data?.entity);
    } catch (err) {
      console.log('getThankYouData err', err);
    }
  };
  return (
    <div className="qs-fade-in px-6 sm:px-10">
      <div className="flex flex-col pt-12 sm:pt-14">
        <div className="flex justify-center">
          <div className="qs-success-icon">
            <img
              src="https://d3cnqzq0ivprch.cloudfront.net/prod/css/images/checkmark-large.png"
              alt="logo"
              className="h-10 w-10 object-contain"
            />
          </div>
        </div>
        <div className="qs-title mt-8 flex items-center justify-center">
          {data?.heading}
        </div>
        <div className="qs-subtitle mx-auto mt-3 flex max-w-md items-center justify-center whitespace-pre-line">
          {data?.body}
        </div>
      </div>
      <div className="mt-10 flex flex-col items-center justify-center border-t border-slate-100 pb-8 pt-6 text-center text-sm leading-snug text-slate-500">
        <div className="flex items-center justify-center">
          {data?.signature}
        </div>
        <div className="flex items-center justify-center">
          {/* {data?.company?.name} */}
        </div>
        <div className="flex items-center justify-center">
          {/* {data?.company?.texting_number} */}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
